export const SEARCH_STATE_CHANGED = "SEARCH_STATE_CHANGED";
export const HITS_LOADED = "HITS_LOADED";
export const OPERATOR_UPDATED = "OPERATOR_UPDATED";
export const HIDE_SKIPPED_CHANGED = "HIDE_SKIPPED_CHANGED";
